import React from 'react';
import PropTypes from 'prop-types';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Switch, Collapse, Select, Checkbox } from 'antd';
import './SideMenu.scss';

const { Panel } = Collapse;
const Option = Select.Option;

class SideMenu extends React.Component {

  _formatClassifications = (json, keyName) => {
    const array = [];
    if (Array.isArray(json)) {
      json.forEach((key) => {
        if (
          this.props.supplierAggs &&
          this.props.supplierAggs[keyName] &&
          this.props.supplierAggs[keyName][key]
        ) {
          array.push({
            label: `${key} (${this.props.supplierAggs[keyName][key]})`,
            value: key,
          });
        }
      })
    } else {
      Object.entries(json).forEach(([key, value]) => {
        if (
          this.props.supplierAggs &&
          this.props.supplierAggs[keyName] &&
          this.props.supplierAggs[keyName][key]
        ) {
          array.push({
            label: `${value} (${this.props.supplierAggs[keyName][key]})`,
            value: key,
          });
        }
      });
    }
    return array;
  };

  render() {
    const {
      onChange,
      supplierSearchCriteria,
      supplierSearchMenuSwitch,
      supplierSearchMenuSelect,
      supplierSearchMenuCamelCase,
    } = this.props;


    return (
      <div className="sidemenu-column-wrapper">
        <div>
          <p style={{ paddingTop: '10px', fontWeight: 600 }}>
            Search Capabilities
          </p>
          <div className="sidemenu-choices-wrapper">
            {supplierSearchMenuSwitch.sort().map((item) => (
              <div className="sidemenu-switch-wrapper" key={supplierSearchMenuCamelCase[item]}>
                <p>{item}</p>
                <Switch
                  checkedChildren={<CheckOutlined />}
                  unCheckedChildren={<CloseOutlined />}
                  onChange={e => {
                    onChange(e, supplierSearchMenuCamelCase[item]);
                  }}
                  checked={supplierSearchCriteria[supplierSearchMenuCamelCase[item]]}
                />
              </div>
            ))}
          </div>
        </div>

        <div>
          <p style={{ fontWeight: 600 }}>Supplier Capabilities</p>
          <Collapse accordion>
            {Object.keys(supplierSearchMenuSelect).sort().map((key) => (
              <Panel header={key} key={supplierSearchMenuCamelCase[key]} >
                {(() => {
                  if (key === "Weight Range") {
                    return (
                      <Select
                        style={{ width: '100%' }}
                        placeholder={`Select ${key}`}
                        optionLabelProp="label"
                        allowClear
                        onChange={e => {
                          onChange(e, supplierSearchMenuCamelCase[key]);
                        }}
                        value={supplierSearchCriteria[supplierSearchMenuCamelCase[key]]}
                      >
                        {this._formatClassifications(supplierSearchMenuSelect[key], key).map(criterium => (
                          <Option value={criterium.value} label={criterium.value}>
                            {criterium.label}
                          </Option>
                        ))}
                      </Select>
                    )
                  } else if (supplierSearchMenuSelect[key].length < 40) {
                    return (
                      <Checkbox.Group
                        onChange={e => {
                          onChange(e, supplierSearchMenuCamelCase[key]);
                        }}
                        style={{ display: 'flex', flexDirection: 'column' }}
                        options={this._formatClassifications(supplierSearchMenuSelect[key], key)}
                        value={supplierSearchCriteria[supplierSearchMenuCamelCase[key]]}
                      />
                    )
                  }
                  return (
                    <Select
                      mode="multiple"
                      style={{ width: '100%' }}
                      placeholder={`Select ${key}`}
                      optionLabelProp="label"
                      allowClear
                      onChange={e => {
                        onChange(e, supplierSearchMenuCamelCase[key]);
                      }}
                      value={supplierSearchCriteria[supplierSearchMenuCamelCase[key]]}
                    >
                      {this._formatClassifications(supplierSearchMenuSelect[key], key).map(criterium => (
                        <Option value={criterium.value} label={criterium.value}>
                          {criterium.label}
                        </Option>
                      ))}
                    </Select>
                  )

                })()}
              </Panel>

            ))}
          </Collapse>
        </div>
      </div >
    );
  }
}

SideMenu.propTypes = {
  supplierAggs: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  supplierSearchCriteria: PropTypes.object.isRequired,
  supplierSearchMenuSwitch: PropTypes.object.isRequired,
  supplierSearchMenuSelect: PropTypes.object.isRequired,
  supplierSearchMenuCamelCase: PropTypes.object.isRequired,
};

export default SideMenu;



// WEBPACK FOOTER //
// ./src/components/SideMenu/SideMenu.jsx